import { photoOverrides } from "./roadMapData";

// Every image dropped into src/images/road-map is picked up automatically by
// webpack (CRA's equivalent of an import glob), so adding a photo to the
// gallery is a matter of copying the file into that folder. Metadata for a
// given file — year, alt text, founder flag — is opt-in via `photoOverrides`.
const context = require.context(
  "../images/road-map",
  false,
  /\.(png|jpe?g|webp)$/
);

// Subtle, deterministic tilt: same file always gets the same angle so the
// collage doesn't reshuffle between renders.
const ROTATIONS = [-4, 2, -1, 3, -2, 4, -3, 1, 0];

const fileName = (key) => key.replace(/^\.\//, "");

export const roadMapPhotos = context
  .keys()
  .sort()
  .map((key, index) => {
    const file = fileName(key);
    const override = photoOverrides[file] || {};

    return {
      id: file,
      file,
      src: context(key),
      rotation: ROTATIONS[index % ROTATIONS.length],
      year: override.year,
      altKey: override.altKey,
      captionKey: override.captionKey,
      featured: Boolean(override.featured),
      ...override,
    };
  })
  // Featured photos (the founder portrait) lead the collage.
  .sort((a, b) => Number(b.featured) - Number(a.featured));

export default roadMapPhotos;
